import { useEffect } from "react";
import { setPageMeta, clearPageMeta } from "../utils/setPageMeta";

/**
 * Apply route-level SEO on mount; clears managed tags on unmount.
 * @param {import("../utils/setPageMeta").PageMetaOptions | null | undefined} config
 */
export function usePageSeo(config) {
  const jsonLdKey = config?.jsonLd == null ? "" : JSON.stringify(config.jsonLd);

  useEffect(() => {
    if (!config) return undefined;
    setPageMeta(config);
    return () => clearPageMeta();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- granular keys avoid re-running on object identity churn
  }, [
    config?.title,
    config?.description,
    config?.ogTitle,
    config?.ogDescription,
    config?.ogImage,
    config?.ogType,
    config?.ogUrl,
    config?.canonicalUrl,
    config?.robots,
    config?.twitterCard,
    jsonLdKey,
  ]);
}
